<template>
  <div
    class="is-margin-top-s pd-x-10"
    :class="{ 'activity-pd': pageNavActivity !== '' && widthMax < 768 }"
  >
    <transition name="slide-fade">
      <div class="loading-integreat" v-if="isLoadingPage">
        <div class="initial-load-animation">
          <div class="linkedin-image"></div>
          <div class="loading-bar">
            <div class="blue-bar"></div>
          </div>
        </div>
      </div>
    </transition>
    <div class="level is-hidden-mobile">
      <div>
        <p class="is-size-5 has-text-weight-semibold pd-y-5">
          {{ $t("document.documentHeader") }}
          <span
            class="textColorMain is-size-6 is-padding-left th"
            v-if="getRule === 'admin' || getRule === 'staff'"
            >{{ userDetail.organizeName }}</span
          >
        </p>
      </div>
      <div>
        <div class="is-flex">
          <div class="has-text-right box-back-page is-flex is-align-center">
            <a
              v-if="getRule !== 'startup'"
              @click="prevPage()"
              class="box-back-page"
            >
              <p
                v-if="pageStatus === 'company'"
                class="text-back-page backpage-color has-text-weight-semibold"
              >
                <i class="fas fa-arrow-left is-margin-right-sm"></i
                >{{ $t("message.btnBackToCompanyList") }}
              </p>
              <p
                v-else-if="pageStatus === 'doc'"
                class="text-back-page backpage-color has-text-weight-semibold"
              >
                <i class="fas fa-arrow-left is-margin-right-sm"></i
                >{{ $t("message.btnBackToDocument") }}
              </p>
              <p
                v-else
                class="text-back-page backpage-color has-text-weight-semibold"
              >
                <i class="fas fa-arrow-left is-margin-right-sm"></i
                >{{ $t("message.btnBackToStaffDetail") }}
              </p>
            </a>
          </div>
          <div
            class="has-text-right is-flex is-align-center is-justify-end is-paddingless"
          >
            <b-dropdown
              ref="dropdowntablet"
              position="is-bottom-left"
              class="mg-5"
            >
              <button class="button btn-Filter" slot="trigger">
                <span class="icon is-small">
                  <i class="fa fa-filter"></i>
                </span>
                <span>{{ $t("message.btnFilter") }}</span>
              </button>
              <b-dropdown-item custom paddingless>
                <div class="modal-card mx-not modal-search">
                  <section class="modal-card-body contentSearch">
                    <div class="headerFilter">
                      <span class="icon is-small is-size-5">
                        <i class="fa fa-filter"></i>
                      </span>
                      <span
                        class="is-padding-sm-x is-size-5 has-text-weight-normal"
                      >
                        {{ $t("message.btnFilter") }}
                      </span>
                    </div>
                    <b-field grouped>
                      <b-input
                        class="is-medium"
                        type="search"
                        icon-pack="fas"
                        icon="search"
                        v-model="searchName"
                        :placeholder="
                          $t('companyDocument.filterPlaceholderDocumentName')
                        "
                        expanded
                      ></b-input>
                    </b-field>
                    <b-field grouped>
                      <b-select
                        expanded
                        v-model="searchType"
                        :placeholder="
                          $t('companyDocument.filterPlaceholderDocumentType')
                        "
                      >
                        <option
                          v-for="option in docType"
                          :value="option.id"
                          :key="option.id"
                        >
                          {{ option.name | capitalize }}
                        </option>
                      </b-select>
                    </b-field>
                    <b-field grouped>
                      <div class="control is-expanded level">
                        <div class="search-btn">
                          <button class="button btnSearch" @click="filter()">
                            {{ $t("message.btnSearch") }}
                          </button>
                        </div>
                        <div class="reset-btn">
                          <button
                            @click="resetFilter()"
                            class="button btnReset th"
                          >
                            {{ $t("message.btnReset") }}
                          </button>
                        </div>
                      </div>
                    </b-field>
                  </section>
                </div>
              </b-dropdown-item>
            </b-dropdown>

            <button
              v-if="
                (getRule === 'startup' &&
                  (user.statusActive === 1 ||
                    user.statusActive === 0 ||
                    user.statusActive === 0)) ||
                getRule === 'staff'
              "
              class="button btn-modal is-margin-left mg-5 mg-r-0 has-text-centered"
              slot="trigger"
              @click="
                [
                  (isDocumentModalAdd = true),
                  $store.commit('setModalActive', true),
                ]
              "
            >
              <span class="text-modal">{{ $t("document.addDocument") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="is-hidden-tablet">
      <div>
        <p class="is-size-6-5 has-text-weight-semibold">
          {{ $t("companyDocument.viewTitleDocument") }}
          <span
            class="textColorMain is-size-6-5 is-padding-left th"
            v-if="getRule === 'admin' || getRule === 'staff'"
            >{{ userDetail.organizeName }}</span
          >
        </p>
      </div>
      <div class="mg-y-15">
        <a v-if="getRule !== 'startup'" @click="prevPage()" class="is-size-7">
          <p
            v-if="pageStatus === 'company'"
            class="backpage-color has-text-weight-semibold"
          >
            <i class="fas fa-arrow-left is-margin-right-sm"></i
            >{{ $t("message.btnBackToCompanyList") }}
          </p>
          <p
            v-else-if="pageStatus === 'doc'"
            class="backpage-color has-text-weight-semibold"
          >
            <i class="fas fa-arrow-left is-margin-right-sm"></i
            >{{ $t("message.btnBackToDocument") }}
          </p>
          <p v-else class="backpage-color has-text-weight-semibold">
            <i class="fas fa-arrow-left is-margin-right-sm"></i
            >{{ $t("message.btnBackToStaffDetail") }}
          </p>
        </a>
      </div>
      <div>
        <div class="is-flex is-align-center is-justify-center is-paddingless">
          <b-dropdown
            ref="dropdownmobile"
            position="is-bottom-left"
            class="mg-5"
          >
            <button class="button btn-Filter-mobile" slot="trigger">
              <span class="icon is-small">
                <i class="fa fa-filter"></i>
              </span>
              <span>{{ $t("message.btnFilter") }}</span>
            </button>
            <b-dropdown-item custom paddingless>
              <div class="modal-card mx-not modal-search">
                <section class="modal-card-body contentSearch">
                  <div class="headerFilter">
                    <span class="icon is-small is-size-5">
                      <i class="fa fa-filter"></i>
                    </span>
                    <span
                      class="is-padding-sm-x is-size-5 has-text-weight-normal"
                    >
                      {{ $t("message.btnFilter") }}
                    </span>
                  </div>
                  <b-field grouped>
                    <b-input
                      class="is-medium"
                      type="search"
                      icon-pack="fas"
                      icon="search"
                      v-model="searchName"
                      :placeholder="$t('message.filterPlaceholderDocumentName')"
                      expanded
                    ></b-input>
                  </b-field>
                  <b-field grouped>
                    <b-select
                      expanded
                      v-model="searchType"
                      :placeholder="$t('message.filterPlaceholderDocumentType')"
                    >
                      <option
                        v-for="option in docType"
                        :value="option.id"
                        :key="option.id"
                      >
                        {{ option.name | capitalize }}
                      </option>
                    </b-select>
                  </b-field>
                  <b-field grouped>
                    <div class="control is-expanded level">
                      <div class="search-btn">
                        <button class="button btnSearch" @click="filter()">
                          {{ $t("message.btnSearch") }}
                        </button>
                      </div>
                      <div class="reset-btn">
                        <button
                          @click="resetFilter()"
                          class="button btnReset th"
                        >
                          {{ $t("message.btnReset") }}
                        </button>
                      </div>
                    </div>
                  </b-field>
                </section>
              </div>
            </b-dropdown-item>
          </b-dropdown>

          <button
            v-if="
              (getRule === 'startup' &&
                (user.statusActive === 1 || user.statusActive === 0)) ||
              getRule === 'staff'
            "
            class="button btn-modal-mobile is-margin-left mg-5 has-text-centered"
            slot="trigger"
            @click="
              [
                (isDocumentModalAdd = true),
                $store.commit('setModalActive', true),
              ]
            "
          >
            <span class="text-modal">{{ $t("document.addDocument") }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="columns is-margin-x-not head-table width-max is-hidden-mobile">
      <div class="column is-5 cr-pointer" @click="sortBy('nameDoc')">
        <p
          class="is-size-7 has-text-weight-semibold is-margin-left-ml"
          :class="{ 'has-text-secondary': currentSort === 'nameDoc' }"
        >
          {{ $t("companyDocument.columnDocumentName") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'nameDoc'"
          ></span>
        </p>
      </div>
      <div
        class="column has-text-centered"
        @click="sortBy('type')"
        :class="{ 'has-text-secondary': currentSort === 'type' }"
      >
        <p class="is-size-7 has-text-weight-semibold cr-pointer">
          {{ $t("companyDocument.columnDocumentType") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'type'"
          ></span>
        </p>
      </div>
      <div
        class="column has-text-centered"
        @click="sortBy('updatedAt')"
        :class="{ 'has-text-secondary': currentSort === 'updatedAt' }"
      >
        <p class="is-size-7 has-text-weight-semibold cr-pointer">
          {{ $t("companyDocument.columnLastUpdated") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'updatedAt'"
          ></span>
        </p>
      </div>
      <div class="column is-1 has-text-centered"></div>
    </div>
    <div
      v-if="documents == '' || documents == null"
      class="is-detail-list detail-table mg-y-15"
    >
      <p class="has-text-drak is-size-4 th is-padding-x-s is-margin-top-s">
        ***
      </p>
      <p class="has-text-drak is-size-6 th is-padding-x has-text-centered">
        {{ $t("document.notFound") }}
      </p>
      <p class="has-text-drak is-size-4 th is-padding-x-s is-margin-top-s">
        ***
      </p>
    </div>

    <div v-else>
      <div
        v-for="(document, index) in documents"
        :key="index"
        class="columns detail-table is-margin-x-not is-vcentered width-max"
        :class="{ 'has-border-primary': index < countNewDoc }"
      >
        <div
          v-if="
            getRule === 'admin' ||
            (getRule === 'startup' &&
              (user.statusActive === 2 || user.statusActive === 4))
          "
          class="column is-1 has-text-right is-hidden-tablet"
        >
          <span class="icon is-large" @click="viewModal(index)">
            <b-tooltip label="view" position="is-bottom" type="is-white">
              <i class="fas fa-eye"></i>
            </b-tooltip>
          </span>
        </div>

        <div
          v-else
          class="column is-1 has-text-right dp-menu-action is-hidden-tablet"
        >
          <b-dropdown
            position="is-top-left"
            class="dropdown-action task-actions not-shadow"
          >
            <button class="button is-crear" slot="trigger">
              <b-tooltip
                label="More"
                position="is-bottom"
                type="is-white"
                :delay="500"
              >
                <b-icon
                  pack="fas"
                  icon="sync-alt"
                  custom-class="fa-ellipsis-v"
                  class="has-text-grey-light pd-20"
                ></b-icon>
              </b-tooltip>
            </button>

            <b-dropdown-item
              @click="viewModal(index)"
              class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
            >
              <div class="dp-link">
                <p class="textActive">{{ $t("message.view") }}</p>
              </div>
            </b-dropdown-item>

            <b-dropdown-item
              @click="editDocument(document.docId)"
              v-if="
                (getRule === 'staff' && document.taskId === '') ||
                (getRule === 'startup' &&
                  (user.statusActive === 1 || user.statusActive === 0) &&
                  document.taskId === '')
              "
              class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
            >
              <div class="dp-link">
                <p class="textActive">{{ $t("message.edit") }}</p>
              </div>
            </b-dropdown-item>

            <b-dropdown-item
              @click="confirmDel(index)"
              v-if="
                (getRule === 'staff' && document.taskId === '') ||
                (getRule === 'startup' &&
                  (user.statusActive === 1 || user.statusActive === 0) &&
                  document.taskId === '')
              "
              class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
            >
              <div class="dp-link">
                <p class="textActive">{{ $t("message.delete") }}</p>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div
          class="column is-5 has-text-centered-mobile th"
          data-label="nameDoc"
        >
          <p
            class="is-size-7 word-ellipsis is-margin-left-ml has-text-weight-normal is-hidden-mobile"
            :title="document.nameDoc"
          >
            {{ document.nameDoc }}
          </p>
          <p
            class="is-size-7 word-ellipsis has-text-weight-normal is-hidden-tablet"
            :title="document.nameDoc"
          >
            {{ document.nameDoc }}
          </p>
        </div>

        <div class="column has-text-centered" data-label="type">
          <p
            class="is-size-7 has-text-weight-semibold"
            v-if="typeName(document.type) === ''"
          >
            {{ $t("document.documentTypeOther") }}
          </p>
          <p class="is-size-7 has-text-weight-semibold" v-else>
            {{ typeName(document.type) | capitalize }}
          </p>
        </div>
        <div class="column has-text-centered" data-label="updatedAt">
          <p class="is-size-7 has-text-weight-semibold">
            {{ dateFomat(document.updatedAt) }}
          </p>
        </div>

        <div
          v-if="
            getRule === 'admin' ||
            (getRule === 'startup' &&
              (user.statusActive === 2 || user.statusActive === 4))
          "
          class="column is-1 has-text-centered is-hidden-mobile"
        >
          <span class="icon is-large" @click="viewModal(index)">
            <b-tooltip label="view" position="is-bottom" type="is-white">
              <i class="fas fa-eye"></i>
            </b-tooltip>
          </span>
        </div>

        <div
          v-else
          class="column is-1 has-text-right dp-menu-action is-hidden-mobile"
        >
          <b-dropdown
            position="is-top-left"
            class="dropdown-action task-actions not-shadow"
          >
            <button class="button is-crear" slot="trigger">
              <b-tooltip
                label="More"
                position="is-bottom"
                type="is-white"
                :delay="500"
              >
                <b-icon
                  pack="fas"
                  icon="sync-alt"
                  custom-class="fa-ellipsis-v"
                  class="is-margin-right-m"
                ></b-icon>
              </b-tooltip>
            </button>

            <b-dropdown-item
              @click="viewModal(index)"
              class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
            >
              <div class="dp-link">
                <p class="textActive">{{ $t("message.view") }}</p>
              </div>
            </b-dropdown-item>

            <b-dropdown-item
              @click="editDocument(document.docId)"
              v-if="
                (getRule === 'staff' && document.taskId === '') ||
                (getRule === 'startup' &&
                  (user.statusActive === 1 || user.statusActive === 0) &&
                  document.taskId === '')
              "
              class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
            >
              <div class="dp-link">
                <p class="textActive">{{ $t("message.edit") }}</p>
              </div>
            </b-dropdown-item>

            <b-dropdown-item
              @click="confirmDel(index)"
              v-if="
                (getRule === 'staff' && document.taskId === '') ||
                (getRule === 'startup' &&
                  (user.statusActive === 1 || user.statusActive === 0) &&
                  document.taskId === '')
              "
              class="has-border-black is-align-center is-justify-center is-flex-medium is-flex-row dp-item-normal is-margin-y-s"
            >
              <div class="dp-link">
                <p class="textActive">{{ $t("message.delete") }}</p>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div class="pd-20 is-hidden-tablet"></div>
      </div>
    </div>
    <div
      v-if="
        documentsAllLength > 10 &&
        docLoad === true &&
        documentsAllLength !== documents.length
      "
      class="is-margin-top-m has-text-centered"
    >
      <a
        @click="LoadMore()"
        class="is-size-7 has-text-weight-semibold is-detail-list"
        >{{ $t("message.btnViewMore") }}</a
      >
    </div>

    <b-modal
      :active.sync="isDocumentModalAdd"
      :width="1000"
      @close="[clearDoc, closeModal()]"
    >
      <div class="card border-inside modalPaddingFocus">
        <div class="card-content">
          <div class="content">
            <h1 class="is-size-4 is-padding-sm-y is-margin-top has-text-left">
              {{ $t("document.addDocument") }}
            </h1>
            <hr />
            <div
              class="is-align-start is-justify-center is-flex-medium is-flex-column"
            >
              <p class="is-size-6 has-text-weight-semibold has-text-left">
                {{ $t("document.modalViewSubtitleName") }}
              </p>
              <b-field
                class="width-max is-padding-sm-y"
                :type="$v.nameFile.$error == true ? 'is-danger' : ''"
              >
                <b-input
                  v-model="nameFile"
                  @input="$v.nameFile.$touch()"
                  type="text"
                  icon-pack="fas"
                  icon="pen"
                  :placeholder="$t('document.addDocumentNamePlaceholder')"
                  expanded
                ></b-input>
              </b-field>
            </div>
            <div
              class="is-align-center is-justify-center is-flex-medium is-flex-row is-margin-top-s"
            >
              <div
                class="is-align-start is-justify-center is-flex-medium is-flex-column"
              >
                <p
                  class="is-size-6 has-text-weight-semibold is-padding-sm-y has-text-left"
                >
                  {{ $t("document.modalViewSubtitleType") }}
                </p>
                <b-dropdown
                  class="dropdown-flex"
                  position="is-bottom-left"
                  v-model="formType"
                  @chang="$v.formType.$touch()"
                >
                  <button
                    class="button width-max"
                    slot="trigger"
                    :class="{ 'form-error-button': $v.formType.$error }"
                  >
                    <template v-if="formType">
                      <span class="icon is-medium">
                        <i
                          class="fas fa-location-arrow has-text-grey-lighter"
                        ></i>
                      </span>
                      <p class="dropdown-text-width">
                        {{ typeName(formType) }}
                      </p>
                      <span class="icon is-small">
                        <i
                          class="fas fa-angle-down has-text-grey-lighter"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </template>
                    <template v-else>
                      <span class="icon is-medium">
                        <i
                          class="fas fa-location-arrow has-text-grey-lighter"
                        ></i>
                      </span>
                      <p
                        class="has-text-grey-lighter dropdown-text-width th is-size-7"
                      >
                        {{ $t("document.addDocumentTypePlaceholder") }}
                      </p>
                      <span class="icon is-small">
                        <i
                          class="fas fa-angle-down has-text-grey-lighter"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </template>
                  </button>

                  <b-dropdown-item
                    v-for="type in docType"
                    :value="type.id"
                    v-bind:key="type.id"
                    class="is-align-center is-flex-medium is-flex-row dropdownItemAddActivity"
                  >
                    <p class="has-text-grey-dark th">
                      {{ type.name | capitalize }}
                    </p>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div
                class="is-align-start is-justify-center is-flex-medium is-flex-column is-padding-left-l"
              />
            </div>
            <div
              class="is-align-start is-flex-medium is-flex-column is-padding-top boxTextArea"
            >
              <p class="is-size-6 has-text-weight-semibold has-text-left">
                {{ $t("document.modalViewSubtitleDescription") }}
              </p>
              <b-field
                class="width-max is-padding-sm-y text-area-pd0"
                :type="$v.descrip.$error == true ? 'is-danger' : ''"
              >
                <b-input
                  v-model="descrip"
                  @input="$v.descrip.$touch()"
                  type="textarea"
                  icon-pack="fas"
                  icon="file-alt"
                  :placeholder="
                    $t('document.addDocumentDescriptionPlaceholder')
                  "
                  expanded
                ></b-input>
              </b-field>
            </div>
            <div
              class="is-align-start is-flex-medium is-flex-column is-padding-top"
            >
              <p class="is-size-6 has-text-weight-semibold has-text-left">
                {{ $t("companyDocument.modalViewSubtitleUploadFile") }}
              </p>
              <b-field class="width-max is-padding-sm-y">
                <b-upload v-model="AddDocUpload" drag-drop>
                  <section class="section">
                    <div
                      class="content has-text-centered is-justify-center is-align-center is-flex-row box-upload"
                    >
                      <b-icon
                        pack="fas"
                        icon="sync-alt"
                        custom-class="fa-cloud-upload-alt"
                        class="icon-upload"
                      ></b-icon>

                      <p
                        v-if="AddDocUpload != ''"
                        class="is-size-8 text-upload is-margin-right-m"
                        ref="fileLabel"
                      >
                        <span class="is-hidden-mobile">{{
                          AddDocUpload.name | snippetMid
                        }}</span>
                        <span class="is-hidden-tablet">{{
                          AddDocUpload.name | snippetMobileSmall
                        }}</span>
                      </p>
                      <span
                        v-else
                        class="is-size-8 text-upload icon-upload"
                        ref="fileLabel"
                      >
                        <span class="placeholder-th is-hidden-mobile">{{
                          $t("document.uploadFilePlaceholder")
                        }}</span>
                        <span class="placeholder-th is-hidden-tablet">{{
                          $t("document.uploadFilePlaceholder2")
                        }}</span>
                      </span>
                      <a class="button btn-upload is-size-7">{{
                        $t("message.chooseFile")
                      }}</a>
                    </div>
                  </section>
                </b-upload>
              </b-field>
            </div>
            <div class="has-text-right has-text-centered-mobile">
              <button class="button btn-modal" slot="trigger" @click="addDoc()">
                <span class="text-modal">{{ $t("document.addDocument") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      :active.sync="isActivityModalActive"
      :width="900"
      @close="closeModal()"
    >
      <div class="card border-inside">
        <div class="card-content">
          <div class="content">
            <h1>{{ $t("companyDocument.modalViewTitleDocumet") }}</h1>
            <hr />
            <div class="columns m-h-auto">
              <div class="column">
                <p class="is-size-5 has-text-weight-semibold is-align-center">
                  <span class="icon is-medium">
                    <i
                      class="fas fa-3x fa-pen iconColorActivity is-margin-right-sm"
                    ></i>
                  </span>
                  {{ $t("companyDocument.modalViewSubtitleName") }}:
                  <span
                    class="confirm-padding-left fw-100 is-hidden-mobile th"
                    style="word-break: break-all"
                    >{{ modalActivity }}</span
                  >
                </p>
                <p class="is-size-5 is-hidden-tablet th">{{ modalActivity }}</p>
              </div>
            </div>
            <div class="columns m-h-auto">
              <div class="column">
                <p
                  class="is-size-5 has-text-weight-semibold is-flex is-align-center"
                >
                  <span class="icon is-medium">
                    <i
                      class="fas fa-3x fa-location-arrow iconColorActivity is-margin-right-sm"
                    ></i>
                  </span>
                  {{ $t("companyDocument.modalViewSubtitleType") }}:
                  <span class="confirm-padding-left fw-100 is-hidden-mobile">{{
                    typeName(modaltype)
                  }}</span>
                  <span
                    v-if="typeName(modaltype) === ''"
                    class="confirm-padding-left fw-100 is-hidden-mobile"
                    >{{ $t("document.documentTypeOther") }}</span
                  >
                </p>
                <p class="is-size-5 is-hidden-tablet">
                  {{ typeName(modaltype) }}
                </p>
              </div>
            </div>
            <div class="columns m-h-auto">
              <div class="column">
                <p class="is-size-5 has-text-weight-semibold is-align-center">
                  <span class="icon is-medium">
                    <i
                      class="fas fa-3x fa-file-alt iconColorActivity is-margin-right-sm"
                    ></i>
                  </span>
                  {{ $t("companyDocument.modalViewSubtitleDescription") }}:
                  <span
                    class="confirm-padding-left fw-100 is-hidden-mobile th"
                    style="word-break: break-all"
                    >{{ modalDescript }}</span
                  >
                </p>
                <p class="is-size-5 is-hidden-tablet th">{{ modalDescript }}</p>
              </div>
            </div>
            <div class="columns m-h-auto">
              <div class="column">
                <p
                  class="is-size-5 has-text-weight-semibold is-flex is-align-center"
                >
                  <span class="icon is-medium">
                    <i
                      class="fas fa-3x fa-file-alt iconColorActivity is-margin-right-sm"
                    ></i>
                  </span>
                  {{ $t("companyDocument.modalViewSubtitleUploadFile") }}:
                  <span
                    class="confirm-padding-left th fw-100 is-hidden-mobile is-padding-right"
                    >{{ modalUploadfile | snippetMiniSmall }}</span
                  >
                  <a
                    :href="filePath + startUpId + '/' + modalDownload"
                    target="_blank"
                    class="is-hidden-mobile is-padding-left iconColorActivity is-flex is-align-center fw-100"
                  >
                    <span class="icon is-medium">
                      <i
                        class="fas fa-3x fa-cloud-download-alt iconColorActivity is-margin-right-sm"
                      ></i>
                    </span>
                    {{ $t("companyDocument.modalViewSubtitleDownloadFile") }}
                  </a>
                </p>
                <p class="is-size-5 th fw-100 is-hidden-tablet">
                  {{ modalUploadfile | snippetMiniSmall }}
                  <a
                    :href="filePath + startUpId + '/' + modalDownload"
                    target="_blank"
                    class="iconColorActivity is-flex is-align-center fw-100"
                  >
                    <span class="icon is-medium">
                      <i
                        class="fas fa-3x fa-cloud-download-alt iconColorActivity is-margin-right-sm"
                      ></i>
                    </span>
                    {{ $t("companyDocument.modalViewSubtitleDownloadFile") }}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      :active.sync="isDocumentModalEdit"
      :width="1000"
      @close="closeModal()"
    >
      <div class="card border-inside modalPaddingFocus">
        <div class="card-content">
          <div class="content">
            <h1 class="is-size-4 is-padding-sm-y is-margin-top">
              {{ $t("companyDocument.modalEditTitleDocumet") }}
            </h1>
            <hr />
            <div
              class="is-align-start is-justify-center is-flex-medium is-flex-column"
            >
              <p class="is-size-6 has-text-weight-semibold">
                {{ $t("companyDocument.modalViewSubtitleName") }}
              </p>
              <b-field
                class="width-max is-padding-sm-y"
                :type="$v.nameFileEdit.$error == true ? 'is-danger' : ''"
              >
                <b-input
                  v-model="nameFileEdit"
                  @input="$v.nameFileEdit.$touch()"
                  type="text"
                  icon-pack="fas"
                  icon="pen"
                  :placeholder="$t('document.addDocumentNamePlaceholder')"
                  expanded
                ></b-input>
              </b-field>
            </div>
            <div
              class="is-align-start is-justify-center is-flex-medium is-flex-row is-margin-top-s"
            >
              <div
                class="is-align-start is-justify-center is-flex-medium is-flex-column"
              >
                <p class="is-size-6 has-text-weight-semibold is-padding-sm-y">
                  {{ $t("companyDocument.modalViewSubtitleType") }}
                </p>
                <b-dropdown
                  class="dropdown-flex"
                  position="is-bottom-left"
                  v-model="isTypeEdit"
                  @change="$v.isTypeEdit.$touch()"
                >
                  <button
                    class="button width-max"
                    slot="trigger"
                    :class="{ 'form-error-button': $v.isTypeEdit.$error }"
                  >
                    <template>
                      <span class="icon is-medium">
                        <i
                          class="fas fa-location-arrow has-text-grey-lighter"
                        ></i>
                      </span>
                      <p class="dropdown-text-width">
                        {{ typeName(isTypeEdit) | capitalize }}
                      </p>
                      <span class="icon is-small">
                        <i
                          class="fas fa-angle-down has-text-grey-lighter"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </template>
                  </button>

                  <b-dropdown-item
                    v-for="type in docType"
                    :value="type.id"
                    v-bind:key="type.id"
                    class="is-align-center is-flex-medium is-flex-row dropdownItemAddActivity"
                  >
                    <p class="has-text-grey-dark">{{ type.name }}</p>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div
                class="is-align-start is-justify-center is-flex-medium is-flex-column is-padding-left-l"
              />
            </div>
            <div
              class="is-align-start is-flex-medium is-flex-column is-padding-top boxTextArea"
            >
              <p class="is-size-6 has-text-weight-semibold">
                {{ $t("companyDocument.modalViewSubtitleDescription") }}
              </p>
              <b-field
                class="width-max is-padding-sm-y text-area-pd0"
                :type="$v.descripEdit.$error == true ? 'is-danger' : ''"
              >
                <b-input
                  v-model="descripEdit"
                  @input="$v.descripEdit.$touch()"
                  type="textarea"
                  icon-pack="fas"
                  icon="file-alt"
                  :placeholder="
                    $t('document.addDocumentDescriptionPlaceholder')
                  "
                  expanded
                ></b-input>
              </b-field>
            </div>
            <div
              class="is-align-start is-flex-medium is-flex-column is-padding-top"
            >
              <p class="is-size-6 has-text-weight-semibold">
                {{ $t("companyDocument.modalViewSubtitleUploadFile") }}
              </p>
              <b-field class="width-max is-padding-sm-y">
                <b-upload v-model="AddDocUploadEdit" drag-drop>
                  <section class="section">
                    <div
                      class="content has-text-centered is-justify-center is-align-center is-flex-row box-upload"
                    >
                      <b-icon
                        pack="fas"
                        icon="sync-alt"
                        custom-class="fa-cloud-upload-alt"
                        class="icon-upload"
                      ></b-icon>
                      <p
                        v-if="AddDocUploadEdit !== null"
                        class="is-size-8 text-upload is-margin-right-m"
                        ref="fileLabel"
                      >
                        <span class="is-hidden-mobile">{{
                          AddDocUploadEdit.name | snippetMid
                        }}</span>
                        <span class="is-hidden-tablet">{{
                          AddDocUploadEdit.name | snippetMobileSmall
                        }}</span>
                      </p>
                      <p
                        v-else
                        class="is-size-8 text-upload icon-upload"
                        ref="fileLabel"
                      >
                        <span class="placeholder-th is-hidden-mobile">{{
                          $t("companyDocument.uploadFilePlaceholder")
                        }}</span>
                        <span class="placeholder-th is-hidden-tablet">{{
                          $t("companyDocument.uploadFilePlaceholder2")
                        }}</span>
                      </p>
                      <a class="button btn-upload is-size-7">{{
                        $t("message.chooseFile")
                      }}</a>
                    </div>
                  </section>
                </b-upload>
              </b-field>
            </div>

            <div class="has-text-right has-text-centered-mobile">
              <button
                @click="saveEditDoc()"
                class="button btn-modal"
                slot="trigger"
              >
                <span class="text-modal">{{
                  $t("companyDocument.modalEditTitleDocumet")
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="isDeleteDocument" :width="900" @close="closeModal()">
      <div class="card modalActivity is-padding-y">
        <div class="card-content">
          <div class="content">
            <div
              class="is-align-center is-justify-center is-flex-medium is-flex-column"
            >
              <p class="is-size-5 confirm-padding-left">
                {{ $t("companyActivityAndTask.confirmDeleteTask") }}
                <a>{{ nameDel }}</a>
                {{ $t("companyActivityAndTask.confirmDeleteSure") }}
              </p>
            </div>
            <div
              class="is-align-center is-justify-center is-flex-medium is-flex-row"
            >
              <button
                class="button btn-delete mg-20"
                slot="trigger"
                @click="
                  delDoc(documents[idSelect].docId, documents[idSelect].files)
                "
              >
                <span class="text-modal">{{ $t("message.btnYes") }}</span>
              </button>
              <button
                class="button btn-delete mg-20"
                slot="trigger"
                @click="
                  [
                    (isDeleteDocument = false),
                    $store.commit('setModalActive', false),
                  ]
                "
              >
                <span class="text-modal">{{ $t("message.btnNo") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script >
import axios from "axios";
import { mapGetters } from "vuex";
import {
  required,
  minLength,
  sameAs,
  between,
  numeric,
  integer,
  helpers,
} from "vuelidate/lib/validators";
import { type } from "os";
import { HTTP } from "../axios.js";

export default {
  validations: {
    nameFile: {
      required,
    },
    descrip: {
      required,
    },
    formType: {
      required,
    },
    nameFileEdit: {
      required,
    },
    isTypeEdit: {
      required,
    },
    descripEdit: {
      required,
    },
    AddDocUpload: {
      required,
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      nameDel: "",
      idSelect: 0,
      isActivityModalActive: false,
      isDocumentModalAdd: false,
      isDocumentModalEdit: false,
      isDeleteDocument: false,
      isType: "",
      modalActivity: "",
      modalDescript: "",
      modalUploadfile: "",
      modalDownload: "",
      modaltype: "",
      filePath: process.env.VUE_APP_DOCUMENT_URL,
      nameFile: "",
      descrip: "",
      AddDocUpload: [],
      formType: "",
      nameFileEdit: "",
      descripEdit: "",
      AddDocUploadEdit: null,
      isTypeEdit: "",
      docEditId: "",
      filterDocument: [],
      searchName: null,
      searchType: null,
      isLoadingPage: null,
      currentSort: "",
      currentSortDir: "desc",
      limitDoc: 10,
      docLoad: true,
      isConnected: false,
      countNewDoc: 0,
      documentsAllLength: 0,
    };
  },
  name: "documentActivities",
  created() {
    if (this.getRule == "startup") {
      this.isLoadingPage = true;
      this.fetchDoc();
    } else {
      this.isLoadingPage = true;
      this.fetchDocAdmin();
    }
  },
  mounted() {
    this.$store.commit("setPageNavActivity", "activity");
    this.documentsAllLength = this.documentsAll.length;
    this.isLoadingPage = false;
  },
  destroyed() {
    this.$store.commit("setPageNavActivity", "");
  },
  sockets: {
    resListDocument(res) {
      let id =
        this.getRule === "startup" ? this.user._id : this.userDetail.startUpId;
      if (res.success === true && res.obj.companyId === id) {
        this.$store.commit("setDocumentsLength", res.obj.document.length);
        this.$store.commit("setDocuments", res.obj.document);
      }
    },
  },
  methods: {
    sortBy(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
      this.countNewDoc = 0;
    },
    closeModal() {
      this.$store.commit("setModalActive", false);
    },
    prevPage() {
      if (this.pageStatus === "company") {
        this.$router.push("/startup-list");
      } else if (this.pageStatus === "doc") {
        this.$router.push("/doc");
      } else {
        this.$router.push("/staff-detail");
      }
    },
    editDocument(id) {
      this.isDocumentModalEdit = true;

      const documents = this.documents.filter(
        (item, index) => item.docId == id
      );

      this.nameFileEdit = documents[0].nameDoc;
      this.descripEdit = documents[0].desc;
      this.AddDocUploadEdit = { name: documents[0].files };
      this.isTypeEdit = documents[0].type;
      this.docEditId = id;
      this.$store.commit("setModalActive", true);
    },
    async saveEditDoc() {
      this.$v.nameFileEdit.$touch();
      this.$v.descripEdit.$touch();
      this.$v.isTypeEdit.$touch();

      if (
        this.$v.nameFileEdit.$invalid ||
        this.$v.descripEdit.$invalid ||
        this.$v.isTypeEdit.$invalid
      ) {
      } else {
        this.isLoadingPage = true;
        const formData = new FormData();

        if (typeof this.AddDocUploadEdit.type !== "undefined") {
          formData.append("file", this.AddDocUploadEdit);
        }

        formData.append("taskId", "");
        formData.append(
          "startUpId",
          this.getRule === "startup" ? "" : this.userDetail.startUpId
        );
        formData.append("type", this.isTypeEdit);
        formData.append("name", this.nameFileEdit);
        formData.append("desc", this.descripEdit);
        formData.append("path", this.AddDocUploadEdit.name);

        const dataDocument = {
          formData,
          tokenAuth: this.token,
          docId: this.docEditId,
        };

        HTTP.defaults.headers.common.Authorization = `Bearer ${dataDocument.tokenAuth}`;
        await HTTP.put(
          `api/document/${dataDocument.docId}`,
          dataDocument.formData
        )
          .then((res) => {
            // console.log('api/document/${dataDocument.docId}',res,dataDocument.docId)
            if (res.data.success) {
              this.isDocumentModalEdit = false;
              this.$store.commit("setModalActive", false);
              this.limitDoc = this.limitDoc;
              if (this.getRule == "startup") {
                this.fetchDoc();
              } else {
                this.fetchDocAdmin();
              }
              this.emitRealTimeDoc();
              this.isLoadingPage = false;
            } else {
              this.isLoadingPage = false;
              this.$buefy.dialog.alert(
                '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
              );
            }
            this.isLoadingPage = false;
          })
          .catch((e) => {
            console.log("api/document/${dataDocument.docId/error}", e);
            this.isLoadingPage = false;
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
            );
          });
      }
    },
    confirmDel(value) {
      this.isDeleteDocument = true;
      this.idSelect = value;
      this.nameDel = this.documents[value].nameDoc;
      this.$store.commit("setModalActive", true);
    },
    async delDoc(id, file) {
      this.isLoadingPage = true;

      const objDoc = {
        token: this.token,
        documentId: id,
        fileName: file,
        startUpId: this.userDetail.startUpId,
        taskId: "",
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post("api/document/delete/file/", objDoc)
        .then((res) => {
          // console.log("api/document/delete/file/", res);
          if (res.data.reultDelete.success) {
            if (this.getRule == "startup") {
              this.fetchDoc();
            } else {
              this.fetchDocAdmin();
            }
            this.emitRealTimeDoc();
            this.isDeleteDocument = false;
            this.$store.commit("setModalActive", false);
            this.limitDoc = 10;
            this.countNewDoc = 0;
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
          this.isLoadingPage = false;
        })
        .catch((e) => {
          console.log("api/document/delete/file/error", e);
          this.isLoadingPage = false;
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
    },
    typeName(id) {
      const docType = this.docType;
      const cat = docType.filter((type) => type.id == id);
      let dataRes = "";
      if (cat.length == 0) {
        dataRes = "";
      } else {
        dataRes = cat[0].name;
      }
      return dataRes;
    },
    async addDoc() {
      this.$v.nameFile.$touch();
      this.$v.descrip.$touch();
      this.$v.formType.$touch();

      if (
        this.$v.nameFile.$invalid ||
        this.$v.descrip.$invalid ||
        this.$v.formType.$invalid
      ) {
      } else if (this.AddDocUpload.length == 0) {
        alert("กรุณาอัพโหลดไฟล์");
      } else {
        this.isLoadingPage = true;
        const formData = new FormData();
        formData.append("file", this.AddDocUpload);
        formData.append("type", this.formType);
        formData.append("name", this.nameFile);
        formData.append(
          "startUpId",
          this.getRule === "startup" ? "" : this.userDetail.startUpId
        );
        formData.append("desc", this.descrip);

        const dataDocument = {
          formData,
          tokenAuth: this.token,
          tokenUpload: this.tokenUpload,
          id:
            this.getRule === "startup"
              ? this.user._id
              : this.userDetail.startUpId,
        };

        HTTP.defaults.headers.common.Authorization = `Bearer ${dataDocument.tokenAuth}`;
        await HTTP.post(
          `api/document/file/upload/${dataDocument.tokenUpload}`,
          dataDocument.formData
        )
          .then((response) => {
            //console.log('api/document/file/upload', response)
            this.isLoadingPage = false;
            if (response.status === 200) {
              this.isDocumentModalAdd = !this.isDocumentModalAdd;
              this.$store.commit("setModalActive", false);
              this.currentSort = "";
              this.countNewDoc = this.countNewDoc + 1;
              this.limitDoc = 10;
              this.clearDoc();

              if (this.getRule == "startup") {
                this.fetchDoc();
              } else {
                this.fetchDocAdmin();
              }
              this.emitRealTimeDoc();
            } else {
              this.$buefy.dialog.alert(
                '<p class="has-text-centered is-size-4">อัพโหลดไฟล์ล้มเหลว</p>'
              );
            }
          })
          .catch((e) => {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-4">อัพโหลดไฟล์ล้มเหลว</p>'
            );
            this.isLoadingPage = false;
            console.log("api/document/file/upload/error", e);
          });
      }
    },
    emitRealTimeDoc() {
      this.$socket.emit("listDocument", {
        batchId: this.batch._id,
        companyId:
          this.getRule === "startup"
            ? this.user._id
            : this.userDetail.startUpId,
      });
    },

    clearDoc() {
      this.nameFile = "";
      this.formType = "";
      this.descrip = "";
      this.AddDocUpload = [];

      this.$v.$reset();
    },
    LoadMore() {
      this.limitDoc = this.limitDoc + 10;
    },
    async fetchDocAdmin() {
      const data = {
        token: this.token,
        batchId: this.batch._id,
        startUpId: this.startUpId,
      };

      await this.$store.dispatch("setTokenUpload", data);
      await this.$store.dispatch("setDocumentStartup", data);
      this.filterDocument = this.documentsAll;
      this.documentsAllLength = this.documentsAll.length;
      this.isLoadingPage = false;
    },
    async fetchDoc() {
      const data = {
        token: this.token,
        batchId: this.batch._id,
        startUpId: this.user._id,
      };

      await this.$store.dispatch("setTokenUpload", data);
      await this.$store.dispatch("setDocumentStartup", data);
      this.filterDocument = this.documentsAll;
      this.documentsAllLength = this.documentsAll.length;
    },
    dateFomat(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "";
      } else {
        res = this.$moment(date).format("DD MMMM Y h:mm a");
      }
      return res;
    },
    viewModal(value) {
      this.isActivityModalActive = true;

      this.modalActivity = this.documents[value].nameDoc;
      this.modalDownload = this.documents[value].files;
      this.modalDescript = this.documents[value].desc;
      this.modaltype = this.documents[value].type;
      this.modalUploadfile = this.documents[value].files;

      this.$store.commit("setModalActive", true);
    },
    resetFilter() {
      this.$store.commit("setDocuments", this.filterDocument);
      this.searchName = null;
      this.searchType = null;
      this.docLoad = true;
      this.limitDoc = 10;
      this.documentsAllLength = this.documentsAll.length;
    },
    filter() {
      if (this.searchName == null && this.searchType == null) {
        this.$store.commit("setDocuments", this.filterDocument);
        var pj = [];
      } else if (this.searchName != null && this.searchType == null) {
        var pj = this.filterDocument.filter(
          (search) =>
            search.nameDoc
              .toLowerCase()
              .indexOf(this.searchName.toLowerCase()) > -1
        );
        this.$store.commit("setDocuments", pj);
      } else if (this.searchName == null && this.searchType != null) {
        var pj = this.filterDocument.filter(
          (search) => search.type == this.searchType
        );
        this.$store.commit("setDocuments", pj);
      } else if (this.searchName != null && this.searchType != null) {
        var pj = this.filterDocument.filter(
          (search) =>
            search.nameDoc
              .toLowerCase()
              .indexOf(this.searchName.toLowerCase()) > -1 &&
            search.type == this.searchType
        );
        this.$store.commit("setDocuments", pj);
      }

      this.limitDoc = 10;
      this.documentsAllLength = pj.length;

      if (pj.length > 10) {
        this.docLoad = true;
      } else {
        this.docLoad = false;
      }

      if (
        typeof this.$refs.dropdowntablet !== "undefined" &&
        typeof this.$refs.dropdownmobile !== "undefined"
      ) {
        this.$refs.dropdowntablet.isActive = false;
        this.$refs.dropdownmobile.isActive = false;
      }
    },
  },
  computed: {
    getRule() {
      return this.$store.state.rule;
    },
    docType() {
      return this.$store.state.docType;
    },
    tokenUpload() {
      return this.$store.getters.tokenUpload;
    },
    startUpId() {
      return this.$store.state.userDetail.startUpId;
    },
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
    batch() {
      return this.$store.state.batch;
    },
    userDetail() {
      return this.$store.state.userDetail;
    },
    documents() {
      let doc = [];
      if (
        typeof this.$store.getters.documents === "undefined" ||
        this.$store.getters.documents === null ||
        this.$store.getters.documents.length === 0
      ) {
        doc = [];
      } else {
        doc = this.$store.getters.documents.sort((a, b) => {
          let modifier = 1;
          if (this.currentSortDir === "desc") modifier = -1;
          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        });
      }
      return doc.slice(0, this.limitDoc);
    },
    documentsAll() {
      return this.$store.getters.documents;
    },
    pageStatus() {
      return this.$store.state.pageStatus;
    },
    pageNavActivity() {
      return this.$store.state.pageNavActivity;
    },
  },
};
</script>
<style>
.containerDocument {
  margin: 1rem;
  /* padding-bottom: 5rem; */
}
.textColorMain {
  color: #00a79d;
}
.box-back-page {
  margin-right: 1rem;
}
.boxBackAndFilter {
  margin-bottom: 1rem;
}
.boxViewMore {
  padding-top: 2rem;
}
.leftTable {
  justify-content: flex-start !important;
  margin-left: 2rem !important;
}
.boxDocument {
  background-color: rgba(63, 186, 138, 0.1);
  padding: 10px;
  border-radius: 7.5px;
  margin-top: 1rem;
}
#docHead {
  padding: 18px;
}
</style>
